import { MegaphoneIcon } from 'lucide-react';
import { Badge } from '@tinct/web-components';
import type { AdsProviderType } from '@tinct/core-api-models';
import type { PageTargetType } from './get-page-display-identity';
import { ADS_PROVIDER_LABELS, AdsProviderIcon } from './ads-provider-badge';

type PageTargetBadgeProps = {
  targetType: PageTargetType | null | undefined;
  /** When known, the chip names the ads provider instead of the generic "Ad". */
  providerType?: AdsProviderType | null;
  className?: string;
};

/**
 * Marks ad-campaign page variants. Lead is the overwhelming default, so it
 * renders nothing for lead pages — only the exception gets a chip.
 */
export function PageTargetBadge({ targetType, providerType, className }: PageTargetBadgeProps) {
  if (targetType !== 'ad_campaign') return null;
  return (
    <Badge variant="secondary" className={`gap-1.5 ${className ?? ''}`.trim()}>
      {providerType ? (
        <>
          <AdsProviderIcon providerType={providerType} />
          {ADS_PROVIDER_LABELS[providerType]}
        </>
      ) : (
        <>
          <MegaphoneIcon className="size-3" />
          Ad
        </>
      )}
    </Badge>
  );
}
